"use client";

import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
// import FileUpload from "./FileUpload";
import { services } from "./data";
import CalModel from "@/components/model/CalModel";

const ContactForm = () => {
  const [selectedServices, setSelectedServices] = useState<string[]>([]);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    company: "",
    notes: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const toggleService = (id: string) => {
    setSelectedServices((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitSuccess(false);

    try {
      const response = await fetch(
        "https://yj0rzekv7e.execute-api.ap-southeast-2.amazonaws.com/default/EmailService-nodemailer",
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fullName: formData.fullName,
            email: formData.email,
            company: formData.company,
            notes: formData.notes,
            type: selectedServices.join(", "),
          }),
        }
      );

      if (!response.ok) {
      }

      setSubmitSuccess(true);
      setFormData({ fullName: "", email: "", company: "", notes: "" });
      setSelectedServices([]);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      // console.log(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="text-white">
      <h2 className="text-[28px] mb-2">
        Let&apos;s Build Something Great Together
      </h2>
      <p className="text-white/95 font-light text-sm mb-6">
        Share your project details with us. We&apos;ll get back to you ASAP
        through email.
      </p>

      {/* Service Selection */}
      <div>
        <div className="grid grid-cols-2 gap-2 sm:gap-3">
          {services.map((service) => (
            <div
              key={service.id}
              className="flex cursor-pointer bg-gray-200/20 border border-gray-100/40 px-3 p-2 rounded-sm font-light items-center space-x-2"
            >
              <Checkbox
                id={service.id}
                checked={selectedServices.includes(service.id)}
                onCheckedChange={() => toggleService(service.id)}
                className="border-white size-3.5 rounded-full"
              />
              <Label
                htmlFor={service.id}
                className="text-[13px] text-white/90 cursor-pointer"
              >
                {service.label}
              </Label>
            </div>
          ))}
        </div>
        <div className="text-xs relative left-[39%] sm:left-[47%] font-light mt-4">
          Not Sure Yet? Let’s Figure It Out Together
        </div>
      </div>

      {/* Form Fields */}
      <form className="space-y-5" onSubmit={handleSubmit}>
        <div>
          <Label htmlFor="fullName" className="font-light mb-1 block">
            Full Name
          </Label>
          <Input
            id="fullName"
            placeholder=""
            className="bg-gray-200/20 mt-2 border-gray-100/40 text-white"
            value={formData.fullName}
            onChange={handleInputChange}
          />
        </div>

        <div>
          <Label htmlFor="email" className="font-light mb-1 block">
            Email
          </Label>
          <Input
            id="email"
            type="email"
            placeholder=""
            className="bg-gray-200/20 mt-2 border-gray-100/40 text-white"
            value={formData.email}
            onChange={handleInputChange}
          />
        </div>

        <div>
          <Label htmlFor="company" className="font-light mb-1 block">
            Company
          </Label>
          <Input
            id="company"
            placeholder=""
            className="bg-gray-200/20 mt-2 border-gray-100/40 text-white"
            value={formData.company}
            onChange={handleInputChange}
          />
        </div>

        <div>
          <Label htmlFor="notes" className="font-light mb-1 block">
            Notes For The Project
          </Label>
          <Textarea
            id="notes"
            placeholder=""
            className="bg-gray-200/20 mt-2 border-gray-100/40 text-white min-h-24 resize-none"
            value={formData.notes}
            onChange={handleInputChange}
          />
        </div>

        {submitSuccess && (
          <div className="text-green-400 font-light">
            Your message has been sent successfully!
          </div>
        )}
        <div className="flex gap-3 text-2xl">
          <Button
            type="submit"
            variant={"outline"}
            className="w-[200px] py-4.5 border-none bg-white"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
          <p>OR </p>
          <CalModel />
        </div>
      </form>
    </div>
  );
};

export default ContactForm;
